module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10213.af8e0bbc.jpg";